import * as React from 'react';
import { FloatingLabel } from 'shared/components/FloatingLabel';
import { OnlineRentalAgreementLabel } from 'shared/components/OnlineRentalAgreementLabel';
import {
  trackLinkClick,
  trackModalShow,
  trackTooltipHover,
} from 'shared/containers/OnlineRentalAgreementLabel/tracking';
import { useOfferSelector } from 'shared/hooks/selectors/useOfferSelector';

export const OnlineRentalAgreementLabelContainer: React.FC = () => {
  const { isOnlineRentalAgreementEnabled } = useOfferSelector();

  if (!isOnlineRentalAgreementEnabled) {
    return null;
  }

  return (
    <FloatingLabel
      labelText="Онлайн-договор"
      tooltipTitle="Онлайн-договор"
      tooltipText="Собственник готов подписать договор аренды онлайн через Госуслуги"
      color="theme-dark"
      backgroundColor="overlay-control-default"
      onOpen={trackTooltipHover}
      extendTooltipContent={<OnlineRentalAgreementLabel onShow={trackModalShow} onClick={trackLinkClick} />}
    />
  );
};
